import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';
import { useAuth } from '@app/hooks/useAuth';
import { Actions } from './Actions';
import { Table } from './Table';

export function PointsHistory() {
  const { isAdmin } = useAuth();

  return (
    <Layout>
      <BreadCrumbs
        links={[
          {
            label: 'Dashboard',
            link: '/',
          },
          {
            label: 'Points History',
            link: '/points/history',
          },
        ]}
      />
      {isAdmin && <Actions />}
      <Table />
    </Layout>
  );
}
